import type { RoleId } from '@onuw/roles-data'

/** The ready-made decks of the role picker (their names: `ui:lobby.presets.<id>`); the decks guide lists them too. */
export const PRESETS: { id: string; roles: Partial<Record<RoleId, number>> }[] = [
  { id: 'classic', roles: { werewolf: 2, seer: 1, robber: 1, troublemaker: 1, villager: 1 } },
  {
    id: 'daybreak',
    roles: {
      werewolf: 1,
      alphaWolf: 1,
      seer: 1,
      witch: 1,
      robber: 1,
      troublemaker: 1,
      revealer: 1,
      insomniac: 1,
    },
  },
  {
    // 9 cards (six players): the Doppelgänger among roles she plays at once, with the wolves, or after them
    id: 'doppelganger',
    roles: {
      doppelganger: 1,
      werewolf: 1,
      mysticWolf: 1,
      minion: 1,
      seer: 1,
      robber: 1,
      troublemaker: 1,
      insomniac: 1,
      revealer: 1,
    },
  },
  {
    // 9 cards (six players): the Vampire roles that hand out, move and read marks
    id: 'marks',
    roles: {
      werewolf: 2,
      cupid: 1,
      diseased: 1,
      instigator: 1,
      priest: 1,
      assassin: 1,
      marksman: 1,
      pickpocket: 1,
    },
  },
  {
    // 9 cards (six players): the Vampires, the Count and the Master against the village
    id: 'vampires',
    roles: {
      vampire: 1,
      count: 1,
      master: 1,
      renfield: 1,
      priest: 1,
      marksman: 1,
      seer: 1,
      robber: 1,
      villager: 1,
    },
  },
  {
    // 9 cards (six players): the Aliens with Groob and Zerb, the Synthetic, the Body Snatcher and friends
    id: 'aliens',
    roles: {
      alien: 1,
      groob: 1,
      zerb: 1,
      syntheticAlien: 1,
      bodySnatcher: 1,
      leader: 1,
      rascal: 1,
      empath: 1,
      seer: 1,
    },
  },
  {
    id: 'chaos',
    roles: {
      werewolf: 1,
      mysticWolf: 1,
      minion: 1,
      seer: 1,
      appSeer: 1,
      robber: 1,
      troublemaker: 1,
      drunk: 1,
      copycat: 1,
      tanner: 1,
    },
  },
  {
    // 14 cards: a full ten-player table that wakes every kind of role
    id: 'big',
    roles: {
      werewolf: 1,
      alphaWolf: 1,
      mysticWolf: 1,
      minion: 1,
      seer: 1,
      appSeer: 1,
      robber: 1,
      witch: 1,
      troublemaker: 1,
      copycat: 1,
      curator: 1,
      alien: 2,
      oracle: 1,
    },
  },
]
